<div class="page-content">
  <div class="toolbar">
    <h2>Agent Profiles</h2>
    <button class="btn-create" disabled>CREATE NEW AGENT +</button>
  </div>

  <div class="agent-section">
    <div class="section-heading">Use a Kyloe-created agent</div>
    <p class="section-subtext">Pre-built Caddi agent profiles — distributed and updated by Kyloe. Add one to your corp and tune it to your desk.</p>
    <div class="agent-table kyloe-table">
      <div class="table-header">
        <span>Entity</span>
        <span>Agent name</span>
        <span>What it does</span>
        <span>Tools</span>
        <span>Status</span>
        <span></span>
      </div>

      <div class="agent-row">
        <div class="entity-cell">
          <span class="entity-dot candidate"></span>
          <span class="entity-label">Candidate</span>
        </div>
        <div class="agent-name"><strong>Candidate Rating Agent</strong></div>
        <div class="agent-description">Scores a candidate against an open job spec and writes a 1–5 rating with rationale.</div>
        <div><span class="tool-badge">Bullhorn</span></div>
        <div><span class="status-badge live">LIVE</span></div>
        <div class="agent-actions">
          <a routerLink="/candidate-rating-agent" class="btn-open">Open</a>
        </div>
      </div>

      <div class="agent-row">
        <div class="entity-cell">
          <span class="entity-dot job"></span>
          <span class="entity-label">Job</span>
        </div>
        <div class="agent-name"><strong>Interview Prep Brief Builder</strong></div>
        <div class="agent-description">Builds a hiring-manager prep brief from the candidate, job and recent notes.</div>
        <div><span class="tool-badge">Bullhorn</span></div>
        <div><span class="status-badge live">LIVE</span></div>
        <div class="agent-actions">
          <a routerLink="/interview-prep-brief" class="btn-open">Open</a>
        </div>
      </div>

      <div class="agent-row">
        <div class="entity-cell">
          <span class="entity-dot candidate"></span>
          <span class="entity-label">Candidate</span>
        </div>
        <div class="agent-name"><strong>CV Formatter</strong></div>
        <div class="agent-description">Strips formatting and places resume text verbatim into a clean, standardised template.</div>
        <div><span class="tool-badge">Bullhorn</span></div>
        <div><span class="status-badge live">LIVE</span></div>
        <div class="agent-actions">
          <a routerLink="/cv-formatter" class="btn-open">Open</a>
        </div>
      </div>

      <div class="agent-row">
        <div class="entity-cell">
          <span class="entity-dot contact"></span>
          <span class="entity-label">Contact</span>
        </div>
        <div class="agent-name"><strong>Client Re-engagement</strong></div>
        <div class="agent-description">Spots dormant accounts and drafts a tailored re-engagement message into the note.</div>
        <div><span class="tool-badge">Bullhorn</span></div>
        <div><span class="status-badge live">LIVE</span></div>
        <div class="agent-actions">
          <a routerLink="/client-reengagement" class="btn-open">Open</a>
        </div>
      </div>
    </div>
  </div>

  <div class="agent-section">
    <div class="section-heading">Developer Agents — Used for debugging</div>
    <div class="agent-table">
      <div class="table-header">
        <span>Agent name</span>
        <span>Description</span>
        <span>Status</span>
        <span></span>
      </div>

      <div class="agent-row">
        <div class="agent-name">
          <span class="entity-dot candidate"></span>
          <strong>Caddi Chat Agent</strong>
        </div>
        <div class="agent-description">Candidate retrieval and Q&amp;A via Bullhorn MCP with per-user session auth.</div>
        <div><span class="status-badge live">LIVE</span></div>
        <div class="agent-actions">
          <a routerLink="/chat" class="btn-open">Open</a>
        </div>
      </div>

      <div class="agent-row">
        <div class="agent-name">
          <span class="entity-dot candidate"></span>
          <strong>BW MCP BH Auth Agent</strong>
        </div>
        <div class="agent-description">Bullhorn agent with OAuth2 authentication and dedicated MCP server integration.</div>
        <div><span class="status-badge live">LIVE</span></div>
        <div class="agent-actions">
          <a routerLink="/bw-mcp-chat" class="btn-open">Open</a>
        </div>
      </div>

      <div class="agent-row">
        <div class="agent-name">
          <span class="entity-dot candidate"></span>
          <strong>Bullhorn Login Assistant</strong>
        </div>
        <div class="agent-description">AI assistant for Bullhorn login guidance and onboarding support.</div>
        <div><span class="status-badge live">LIVE</span></div>
        <div class="agent-actions">
          <a routerLink="/bullhorn-login-assistant" class="btn-open">Open</a>
        </div>
      </div>

      <div class="agent-row">
        <div class="agent-name">
          <span class="entity-dot candidate"></span>
          <strong>Bullhorn Session Identity</strong>
        </div>
        <div class="agent-description">Identifies the currently authenticated Bullhorn user and session details.</div>
        <div><span class="status-badge live">LIVE</span></div>
        <div class="agent-actions">
          <a routerLink="/bullhorn-session-identity" class="btn-open">Open</a>
        </div>
      </div>
    </div>
  </div>
</div>
